import { useEffect, useRef } from 'react';

import '../consts/events.quiz-detail-page-view';

import { trackEvent } from '@zep/logger/tracking';

import { useIsLoggerUserInfoSet } from '@/lib/auth';

/**
 * 유저 정보가 로거에 실린 뒤에 찍는다. 그 전에는 소유자도 비로그인으로 판정돼 `is_owner` 가 틀린다.
 */
export const useQuizDetailPageView = ({
  quizSetId,
  isLocked,
  isOwner,
}: {
  quizSetId: string | undefined;
  isLocked: boolean;
  isOwner: boolean;
}) => {
  const isLoggerUserInfoSet = useIsLoggerUserInfoSet();
  const viewedQuizSetIdRef = useRef<string>();

  useEffect(() => {
    if (!quizSetId || !isLoggerUserInfoSet) return;
    if (viewedQuizSetIdRef.current === quizSetId) return;
    viewedQuizSetIdRef.current = quizSetId;

    trackEvent('quiz_detail_page_view', {
      quiz_set_id: quizSetId,
      is_locked: isLocked,
      is_owner: isOwner,
    });
  }, [quizSetId, isLocked, isOwner, isLoggerUserInfoSet]);
};
